module.exports = "<router-outlet></router-outlet>\n<div toastContainer id=\"AlertError\"></div>"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main